import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateDatetimeInputFormField(
  params: FormFieldGenerationParams<'datetimeInput'>,
): PartialPropsOf<'datetimeInput'> {
  let props: PartialPropsOf<'datetimeInput'> = applyPropsPatch(params.props, {
    content: { time: { enabled: false } },
    style: { general: { offset: { margin: '$t.spacingFormField' } } },
  });

  if (params.inputData.column.columnType === 'Date') {
    props = applyPropsPatch(props, { content: { time: { enabled: false } } });
  }

  if (params.inputData.column.columnType === 'Time') {
    props = applyPropsPatch(props, {
      content: { date: { enabled: false }, time: { enabled: true } },
    });
  }

  return props;
}
